'use client';

import { motion } from 'framer-motion';
import { Link } from '@/i18n/navigation';
import { Sparkles, ScanLine, ArrowRight } from 'lucide-react';
import Container from './ui/container';

export function MidPageCta() {
	return (
		<Container>
			<motion.div
				className="max-w-5xl mx-auto rounded-3xl bg-slate-900 border border-slate-800 text-white p-7 sm:p-12 text-center relative overflow-hidden shadow-lg"
				initial={{ opacity: 0, y: 30 }}
				whileInView={{ opacity: 1, y: 0 }}
				viewport={{ once: true }}
				transition={{ duration: 0.5 }}
			>
				{/* Background decorative gradient */}
				<div className="absolute -top-24 -right-24 size-64 bg-emerald-500/15 rounded-full blur-3xl pointer-events-none" />
				<div className="absolute -bottom-24 -left-24 size-64 bg-teal-500/15 rounded-full blur-3xl pointer-events-none" />

				<div className="relative z-10 max-w-2xl mx-auto">
					<div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-emerald-500/10 border border-emerald-400/20 text-emerald-300 text-xs sm:text-sm font-semibold mb-4">
						<span className="flex size-2 rounded-full bg-emerald-400 animate-pulse" />
						<span>No Credit Card • No Expiration Trap</span>
					</div>
					<h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight mb-3 text-white">
						Start Creating Free Custom QR Codes
					</h2>
					<p className="text-slate-300 text-sm sm:text-base leading-relaxed mb-6 sm:mb-8 max-w-xl mx-auto">
						Design personalized QR codes with custom logos, frames, and colors, or launch 11+
						dynamic mobile experiences in seconds.
					</p>
					<div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 max-w-sm sm:max-w-none mx-auto">
						<Link
							href="/create"
							className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#0f766e] hover:bg-[#115e59] active:bg-[#134e4a] text-white font-semibold text-sm px-6 py-3.5 rounded-2xl shadow-sm hover:shadow-md transition-all active:scale-[0.98]"
						>
							<Sparkles className="size-4" />
							<span>Create Free QR Code</span>
							<ArrowRight className="size-4 ml-0.5" />
						</Link>
						<Link
							href="/scanner"
							className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-slate-800 hover:bg-slate-700 active:bg-slate-600 text-slate-200 hover:text-white font-semibold text-sm px-5 py-3.5 rounded-2xl border border-slate-700/80 shadow-2xs transition-all active:scale-[0.98]"
						>
							<ScanLine className="size-4 text-emerald-400" />
							<span>Scan Barcode / QR</span>
						</Link>
					</div>
				</div>
			</motion.div>
		</Container>
	);
}

export default MidPageCta;
